export default __webpack_public_path__ + "static/media/Fondo.a899072c.jpg";